import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status: "idle",
  error: null,
  message: null,
};

export const deleteHomeLinkSlice = createSlice({
  name: "deleteHomeLink",
  initialState,
  reducers: {
    deleteHomeLinkRequested: (state) => {
      state.status = "loading";
      state.error = null;
      state.message = null;
    },
    deleteHomeLinkRequestFailed: (state, action) => {
      state.status = "failed";
      state.error = action.payload;
    },
    deleteHomeLinkRequestSucceeded: (state, action) => {
      state.status = "succeeded";
      state.message = action.payload;
    },
  },
});

export const {
  deleteHomeLinkRequested,
  deleteHomeLinkRequestFailed,
  deleteHomeLinkRequestSucceeded,
} = deleteHomeLinkSlice.actions;

export default deleteHomeLinkSlice.reducer;
